export const ukrainianAlphabet = {
  'U+0410': 1040, // A
  'U+0430': 1072, // a
  'U+0411': 1041, // Б
  'U+0431': 1073, // б
  'U+0412': 1042, // В
  'U+0432': 1074, // в
  'U+0413': 1043, // Г
  'U+0433': 1075, // г
  'U+0490': 1168, // Ґ
  'U+0491': 1169, // ґ
  'U+0414': 1044, // Д
  'U+0434': 1076, // д
  'U+0415': 1045, // Е
  'U+0435': 1077, // е
  'U+0404': 1028, // Є
  'U+0454': 1108, // є
  'U+0416': 1046, // Ж
  'U+0436': 1078, // ж
  'U+0417': 1047, // З
  'U+0437': 1079, // з
  'U+0418': 1048, // И
  'U+0438': 1080, // и
  'U+0406': 1030, // І
  'U+0456': 1110, // і
  'U+0407': 1031, // Ї
  'U+0457': 1111, // ї
  'U+0419': 1049, // Й
  'U+0439': 1081, // й
  'U+041A': 1050, // К
  'U+043A': 1082, // к
  'U+041B': 1051, // Л
  'U+043B': 1083, // л
  'U+041C': 1052, // М
  'U+043C': 1084, // м
  'U+041D': 1053, // Н
  'U+043D': 1085, // н
  'U+041E': 1054, // О
  'U+043E': 1086, // о
  'U+041F': 1055, // П
  'U+043F': 1087, // п
  'U+0420': 1056, // Р
  'U+0440': 1088, // р
  'U+0421': 1057, // С
  'U+0441': 1089, // с
  'U+0422': 1058, // Т
  'U+0442': 1090, // т
  'U+0423': 1059, // У
  'U+0443': 1091, // у
  'U+0424': 1060, // Ф
  'U+0444': 1092, // ф
  'U+0425': 1061, // Х
  'U+0445': 1093, // х
  'U+0426': 1062, // Ц
  'U+0446': 1094, // ц
  'U+0427': 1063, // Ч
  'U+0447': 1095, // ч
  'U+0428': 1064, // Ш
  'U+0448': 1096, // ш
  'U+0429': 1065, // Щ
  'U+0449': 1097, // щ
  'U+042C': 1068, // Ь
  'U+044C': 1100, // ь
  'U+042E': 1070, // Ю
  'U+044E': 1102, // ю
  'U+042F': 1071, // Я
  'U+044F': 1103, // я
};
